var _circle, _circle2, _g, _circle3, _circle4, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#1F2028"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 64,
    height: 64,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "#1F2028",
    stroke: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32 72.212.96 8.983l8.08-3.966L32 51.788 54.96 5.017l8.08 3.966L32 72.212Z",
    clipRule: "evenodd",
    opacity: 0.8
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "url(#b)",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "#1F2028"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23.407 22.3c-.386-1.73.965-3.366 2.703-3.366 1.545 0 2.8 1.25 2.8 2.79v6.347c.966-.097 1.931-.193 2.993-.193.966 0 1.931.096 2.897.193v-6.348a2.796 2.796 0 0 1 2.8-2.789c1.738 0 3.09 1.635 2.8 3.366l-1.255 6.925C43.2 30.763 46 33.456 46 36.534c0 4.712-6.276 8.559-14 8.559s-14-3.847-14-8.56c0-3.077 2.703-5.77 6.759-7.308L23.407 22.3Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2028",
    d: "M28.041 35.86c0 1.25-.675 2.309-1.544 2.309-.87 0-1.545-1.058-1.545-2.309 0-1.25.675-2.308 1.544-2.308.87 0 1.545 1.058 1.545 2.308Zm10.717 0c0 1.25-.676 2.309-1.545 2.309-.869 0-1.544-1.058-1.544-2.309 0-1.25.675-2.308 1.544-2.308.87 0 1.545 1.058 1.545 2.308Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 59.284,
    x2: -9.421,
    y1: 48.315,
    y2: 6.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CFFA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVCake);
export default __webpack_public_path__ + "static/media/vCake.073fb3c199e06d2597e04bd2742ab894.svg";
export { ForwardRef as ReactComponent };